import React, {useState, useEffect} from "react";
import TabPageHeader from "../../header/tabpageheader";
import MDBox from "../../../../../../components/MDBox";
import GenericForm from "../../../../../dialog/genericform";
import {getFields} from "../../../../../dialog/formfields";
import PropTypes from "prop-types";
import useConfigApi from "../../../../../utils/configapi";
import Endpoints from "../../../../../utils/endpoints";
import toast from "react-hot-toast";





const TerminalConfig = ({ selectedRowData }) => {
    const [initialData, setInitialData] = useState({});
    const [fields, setFields] = useState([]);
    const api = useConfigApi();
    const { terminalConfigFields, terminalValidationSchema } = getFields();


    const fetchCurrencyConfigs = async () => {
        try {
            // 1. Fetch Control Config
            const currencyConfigResponse = await api.get(Endpoints.currencyConfig.getByControlSlNo(selectedRowData.slNo));
            const currencyConfig = currencyConfigResponse?.data?.data || [];
            const currencyOptions = currencyConfig.map(currency => ({
                value: currency.slNo,
                label: `${currency.currencyCode} - ${currency.currencyName}`
            }));
            return currencyOptions;

        } catch (error) {
            toast.error("Error while fetching currency config or host data.");
            console.error(error);
        }
    };

    const fetchTerminalConfig = async () => {
        try {
            // console.log(selectedRowData);
            const response = await api.get(Endpoints.terminalConfig.getByControlSlNo(selectedRowData.slNo));
            const data = response?.data?.data || {};
            const sanitizedData = Object.fromEntries(
                Object.entries(data).map(([key, value]) => [key, value ?? ""])
            );

            // ensure defaultCurrency is a flat slNo string
            setInitialData({
                ...sanitizedData,
                defaultCurrency: sanitizedData?.defaultCurrency?.slNo || "",
            });
            let updatedFields = [...terminalConfigFields];
            if (data.slNo) {
                const currencyOptions = await fetchCurrencyConfigs();
                updatedFields = [
                    {
                        name: "slNo",
                        label: "SL No",
                        readonly: true,
                        value: data.slNo,
                        hidden: true
                    },
                    { name: "defaultCurrency", label: "Default Currency",type: "select", options: currencyOptions, required: true },
                    ...updatedFields,
                ];
            }
            setFields(updatedFields);
            // console.log("Terminal config data:", initialData);
        } catch (error) {
            console.error("Failed to fetch terminal config:", error);
            setFields(terminalConfigFields);
        }
    };

    useEffect(() => {
        fetchTerminalConfig().catch(console.error);
    }, [selectedRowData]);

    const handleRevertAll = () => { /* ... */ };
    const handleValidate = (formData) => {
        delete formData.controlId;
        formData.controlConfigSerialNumber  = selectedRowData.slNo;
        console.log("form data", formData);
        if(formData.slNo) {
            api.put(Endpoints.terminalConfig.createOrUpdate, formData)
                .then((response) => {
                    toast.success("Terminal config successfully updated.");
                    console.log(response);
                    fetchTerminalConfig().catch(console.error);
                })
                .catch((error) => {
                    console.log(error);
                    const message = error?.response?.data?.responseMessage || "Something went wrong.";
                    toast.error(message);
                });
        } else {
            api.post(Endpoints.terminalConfig.createOrUpdate, formData)
                .then((response) => {
                    toast.success("Terminal config successfully created.");
                    console.log(response);
                    fetchTerminalConfig().catch(console.error);
                })
                .catch((error) => {
                    toast.error("Internal error occurred while creating.");
                });
        }

    };

    return (
        <>
            <MDBox
                sx={{
                    px: 3,
                    py: 2,
                    bgcolor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <TabPageHeader
                    title="Terminal Config"
                    showButton={false}
                />
            </MDBox>
            <MDBox sx={{
                px: 3,
                py: 2,
                bgcolor: "#fff",
                borderBottom: "1px solid #d3e3fd",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}>
                {fields.length > 0 && (
                    <GenericForm
                        title="Terminal Config"
                        fields={fields}
                        initialData={initialData}
                        useDialog={false}
                        mode="edit"
                        onValidate={handleValidate}
                        onRevertAll={handleRevertAll}
                        validationSchema={terminalValidationSchema}
                    />
                )}
            </MDBox>


        </>

    );
};
TerminalConfig.propTypes = {
    selectedRowData: PropTypes.shape({
        controlName: PropTypes.string,
        controlType: PropTypes.string,
        slNo: PropTypes.number,
    }),
};
export default TerminalConfig;
